/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { DELIVERY_COST_OCC } from './delivery-cost.occ';
import { map } from 'rxjs';
import { DeliveryCost } from './delivery-cost.model';
import { deliveryCostMock } from './delivery-cost.mock';

@Injectable({
  providedIn: 'root',
})
export class DeliveryCostService {
  constructor(
    private http: HttpClient,
    private occEndpoints: OccEndpointsService,
  ) {}

  getDeliveryCost(zipCode: string) {
    const url = this.occEndpoints.buildUrl(DELIVERY_COST_OCC.SEARCH, { queryParams: { zipCode } });

    return this.http.get(url).pipe(map((data: any) => this.normalizeDeliveryCost(data)));
  }

  normalizeDeliveryCost(data: any): DeliveryCost {
    return deliveryCostMock;
  }
}
